/// <reference types="vite/client" />
import { type WorkflowsClientInterface } from './workflowsClient.types';
import LocalStorageWorkflowsClient from './localStorageWorkflowsClient';
import type { ClientContext } from '~/services/contextClient';

// TODO: remove before real client — simulates network latency for the localStorage prototype only
const fakeDelay = (): Promise<void> => {
    if (import.meta.env.VITEST || !import.meta.env.DEV) {
        return Promise.resolve();
    }
    return new Promise((resolve) => setTimeout(resolve, 500 + Math.random() * 500));
};

function withNetworkDelay(client: WorkflowsClientInterface): WorkflowsClientInterface {
    return new Proxy(client, {
        get(target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (typeof value !== 'function') {
                return value;
            }
            return async (...args: unknown[]) => {
                await fakeDelay();
                return (value as (...a: unknown[]) => unknown).apply(target, args);
            };
        },
    });
}

export default class WorkflowsClientFactory {
    static createClient(_context: ClientContext): WorkflowsClientInterface {
        // A single localStorage-backed fake serves every context today. The real
        // per-context HTTP client plugs in here later with no changes to the UI: it returns
        // the workflow JSON essentially as-is and each step component reads its own fields,
        // so no central transformer sits between the API and the canvas.
        return withNetworkDelay(new LocalStorageWorkflowsClient());
    }
}
